import React, { useCallback, useEffect, useState } from 'react';
import AdminShell, { useAdminKey } from '../components/admin/AdminShell';

const FeedbackBody = () => {
  const { adminKey } = useAdminKey();
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchFeedback = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/feedback`, {
        headers: { 'X-Admin-Key': adminKey },
      });
      if (res.ok) {
        const data = await res.json();
        setFeedback(data.feedback || []);
      } else {
        alert('Failed to load feedback');
      }
    } catch (err) {
      console.error(err);
      alert('Error loading feedback');
    }
    setLoading(false);
  }, [API_URL, adminKey]);

  useEffect(() => {
    fetchFeedback();
  }, [fetchFeedback]);

  const handleAction = async (id, action) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/feedback/${id}/review`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Admin-Key': adminKey,
        },
        body: JSON.stringify({ action, reviewer_note: '' }),
      });
      if (res.ok) {
        setFeedback((f) => f.filter((x) => x._id !== id));
      } else {
        alert('Action failed');
      }
    } catch (err) {
      console.error(err);
      alert('Error');
    }
  };

  return (
    <div data-testid="admin-feedback-body">
      {loading && <p className="text-sm text-[#6B6560]">Loading…</p>}
      {!loading && feedback.length === 0 && (
        <p className="text-sm text-[#6B6560]">No pending feedback. You're all caught up.</p>
      )}
      <div className="space-y-4">
        {feedback.map((item) => (
          <div
            key={item._id}
            className="bg-white border border-[#E8DED3] p-4 rounded-xl"
            data-testid={`admin-feedback-row-${item._id}`}
          >
            <div className="flex justify-between items-start gap-4">
              <div className="min-w-0">
                <p className="font-semibold text-[#2C2823]">{item.school_name}</p>
                <p className="text-xs text-[#9B8F88]">
                  {new Date(item.created_at).toLocaleString()}
                </p>
                <p className="text-sm mt-1">
                  <strong>Field:</strong> {item.field}
                </p>
                <p className="text-sm">
                  <strong>Comment:</strong> {item.their_comment || '—'}
                </p>
              </div>
              <div className="flex gap-2 shrink-0">
                <button
                  onClick={() => handleAction(item._id, 'approved')}
                  className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1 rounded text-sm"
                  data-testid={`admin-feedback-approve-${item._id}`}
                >
                  Approve
                </button>
                <button
                  onClick={() => handleAction(item._id, 'rejected')}
                  className="bg-gray-400 hover:bg-gray-500 text-white px-3 py-1 rounded text-sm"
                  data-testid={`admin-feedback-reject-${item._id}`}
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const AdminFeedbackPage = () => (
  <AdminShell
    title="Feedback queue"
    subtitle="Content moderation for user-submitted feedback"
  >
    <FeedbackBody />
  </AdminShell>
);

export default AdminFeedbackPage;
